




























import { defineComponent } from '@nuxtjs/composition-api';
import icons from '@shared/ui/storefront-ui/icons/icons';
import { iconColorsValues as SF_COLORS } from '@shared/ui/storefront-ui/variables/colors';
import { sizesValues as SF_SIZES } from '@shared/ui/storefront-ui/variables/sizes';
const SF_ICONS = Object.keys(icons);

export default defineComponent({
  name: 'BaseIcon',
  props: {
    icon: {
      type: [String, Array],
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    viewBox: {
      type: String,
      default: '0 0 24 24',
    },
    coverage: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    isSFColors(): any {
      return SF_COLORS.includes(this.color.trim());
    },
    isSFSizes(): any {
      const size = this.size.trim();
      return SF_SIZES.includes(size);
    },
    iconColorClass(): any {
      return this.isSFColors ? `color-${this.color.trim()}` : '';
    },
    iconSizeClass(): any {
      if (this.isSFSizes) {
        switch (this.size.trim()) {
          case 'xxs':
            return 'size-xxs';
          case 'xs':
            return 'size-xs';
          case 'sm':
            return 'size-sm';
          case 'md':
            return 'size-md';
          case 'lg':
            return 'size-lg';
          case 'xl':
            return 'size-xl';
          case 'xxl':
            return 'size-xxl';
          case 'xl3':
            return 'size-xl3';
          case 'xl4':
            return 'size-xl4';
          default:
            return 'size-lg';
        }
      } else {
        return '';
      }
    },
    iconCustomStyle(): any {
      return {
        '--icon-color': !this.isSFColors ? this.color : '',
        '--icon-size': !this.isSFSizes ? this.size : '',
      };
    },
    isSFIcons(): any {
      if (typeof this.icon === 'string') {
        return SF_ICONS.includes(this.icon.trim());
      } else return null;
    },
    iconViewBox(): any {
      // @ts-ignore migrated from ui-library
      return this.isSFIcons ? icons[this.icon].viewBox || this.viewBox : this.viewBox;
    },
    iconPaths(): any {
      if (this.isSFIcons) {
        // @ts-ignore migrated from ui-library
        return icons[this.icon].paths;
      } else {
        return Array.isArray(this.icon) ? this.icon : [this.icon];
      }
    },
    fillPath(): any {
      return this.coverage === 1 ? 'var(--icon-color)' : this.fillPathUrl(this._uid);
    },
  },
  methods: {
    // @ts-ignore migrated from ui-library
    fillPathUrl(uid) {
      return `url(#linearGradient-${uid})`;
    },
  },
});
